module.exports = __webpack_public_path__ + "static/hero-desktop-95880b5752c36f0fb611cbe28331d72a.jpg";